<!-- src/components/Header.vue -->
<script setup>
import PowerLogoutIcon from "@/components/PowerLogoutIcon.vue";
import { computed } from "vue";

const props = defineProps({
  progress: { type: Number, default: 0 },
  onLogout: { type: Function, required: true },
  // parent controls nav open/closed state
  active: { type: Boolean, default: false },
  activeMain: { type: String, default: "PIM" }
});
const mainLabel = computed(() => {
  switch (props.activeMain) {
    case "CP":   return "ComfortPages";
    case "SAP":  return "SAP";    
    case "BMD":  return "BMD";
    case "BASE": return "Base";
    case "PIM":
    default:
      return "PIM";
  }
});
const emit = defineEmits(["toggle-nav"]);

function toggleHamburger() {
  emit("toggle-nav");
}
</script>

<template>
  <header class="nz-header">

    <span class="nz-main-label">
      {{ mainLabel }}
    </span>
    <!-- Hamburger -->
    <button
      :class="{
        'nz-hamburger': true,
        open: props.active
      }"
      @click="toggleHamburger"
    >
      <svg
        class="ham hamRotate ham4"
        :class="{ active: props.active }"
        viewBox="0 0 100 100"
        width="80"
      >
        <path
          class="line top"
          d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5
             0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20"
        />
        <path class="line middle" d="m 70,50 h -40" />
        <path
          class="line bottom"
          d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5
             0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"
        />
      </svg>
    </button>

    <div class="nz-logo"></div>

    <PowerLogoutIcon
      :progress="props.progress"
      :size="30"
      class="logout-icon"
      @click="props.onLogout"
    />
  </header>
</template>

<style lang="less" scoped>
.nz-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.nz-logo {
  flex: 1;
}

.nz-main-label{
  position: absolute;
  top: 6px;
  right: 135px;
  color: @accent;
  font-family: "nz-header";
  font-size: 2rem;

}

.nz-hamburger {
  position: absolute;
  z-index: 99;
  top: -9px;
  right: 40px;
  font-size: 24px;
  padding: 0 10px;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  transform: scale(.7);
  transition: all 1s ease;
}

.nz-hamburger.open {
  right: -20px;
}

/* SVG Animation */
.ham {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 400ms;
  user-select: none;
}
.hamRotate.active {
  transform: rotate(45deg);
}
.hamRotate180.active {
  transform: rotate(180deg);
}

.line {
  fill: none;
  transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
  stroke: @nodezone-dark;
  stroke-width: 3;        /* thinner */
  stroke-linecap: round;
}

.ham4 .top {
  stroke-dasharray: 40 121;
}
.ham4 .bottom {
  stroke-dasharray: 40 121;
}

.ham4.active .top {
  stroke-dashoffset: -68px;
}
.ham4.active .bottom {
  stroke-dashoffset: -68px;
}

.logout-icon {
  cursor: pointer;
}
</style>
